export default __webpack_public_path__ + "static/shots-compressed-4d960ee7f29bc2586241e66acd3cc9e3.mp4";